import { render } from "./BranchSelectionDialogContent.vue?vue&type=template&id=e976997c&scoped=true"
import script from "./BranchSelectionDialogContent.vue?vue&type=script&lang=js"
export * from "./BranchSelectionDialogContent.vue?vue&type=script&lang=js"

import "./BranchSelectionDialogContent.vue?vue&type=style&index=0&id=e976997c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e976997c"]])

export default __exports__